import store from "./store";
import { api } from "./api";

export default {
    text(t) { return this.types.find(it => it.value === t).text; },
    types: [
        { value: "semrush_keyword_rank_branded_2", text: "Semrush: Branded" },
        { value: "semrush_keyword_rank_nonbranded_2", text: "Semrush: Non-branded" },
        { value: "dataforseo_branded", text: "DataForSEO: Branded" },
        { value: "dataforseo_nonbranded", text: "DataForSEO: Non-branded" },
        { value: "uptime2", text: "Uptime Rank" },
        { value: "linkedin", text: "LinkedIn" },
        { value: "sari", text: "SARI" },
        { value: "ofks", text: "OFKS" },
        { value: "primalgo", text: "Primalgo" },
        { value: "lsi", text: "LSI Keywords" },
        { value: "cleverreach", text: "Cleverreach" },
        { value: "custom", text: "Custom" },
        { value: "impaxis", text: "Impaxis (legacy)" },
        { value: "impaxis.medicrops", text: "Impaxis: Medicrops" },
        { value: "impaxis.swisspets", text: "Impaxis: Swiss Pet Solution" },
        { value: "impaxis.gerstl", text: "Impaxis: Gerstl" },
    ],
    get: id => store.state.products.find(it => it.id === id),
    list: () => store.state.products,
    refresh: async () => {
        let products = await api("/products/list");

        store.commit("mutate", { products: products || [] })
    }
};